<template>
    <div class="u-mt-20" style="padding: 20px 12px;">
        <h4>Aulas e planejamento</h4>
        <p class="pa-sub">Aulas realizadas, conteúdo ministrado e planejamento aprovado.</p>

        <el-row :gutter="8" class="u-mb-10">
            <el-col :xs="12" :sm="8" :md="6">
                <el-date-picker v-model="de" type="date" size="mini" placeholder="De"
                                value-format="yyyy-MM-dd" format="dd/MM/yyyy" style="width:100%" />
            </el-col>
            <el-col :xs="12" :sm="8" :md="6">
                <el-date-picker v-model="ate" type="date" size="mini" placeholder="Até"
                                value-format="yyyy-MM-dd" format="dd/MM/yyyy" style="width:100%" />
            </el-col>
            <el-col :xs="24" :sm="8" :md="6" class="u-mt-5-mobile">
                <el-button size="mini" type="primary" :loading="loading" @click="carregar" style="width:100%">
                    Buscar
                </el-button>
            </el-col>
        </el-row>

        <el-alert v-if="erro" type="warning" :closable="false" show-icon :title="erro" class="u-mb-10" />

        <div v-if="loading" class="pa-loading"><img src="/public/img/loading-bar.gif" /></div>

        <el-tabs v-else v-model="aba">

            <el-tab-pane label="Aulas" name="aulas">
                <div v-if="aulas.length === 0" class="pa-vazio">Nenhuma aula registrada no período.</div>

                <el-table v-else :data="aulas" stripe size="mini" style="width:100%">
                    <el-table-column label="Data" width="100">
                        <template slot-scope="s">{{ formatarData(s.row.data) }}</template>
                    </el-table-column>
                    <el-table-column label="Componente" min-width="130">
                        <template slot-scope="s">{{ s.row.componente || '—' }}</template>
                    </el-table-column>
                    <el-table-column label="Conteúdo" min-width="200">
                        <template slot-scope="s">
                            <div>{{ s.row.conteudo_ministrado || '—' }}</div>
                            <div v-if="s.row.planejamento" class="pa-menor">
                                Planejamento: {{ s.row.planejamento.titulo }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Presença" width="120">
                        <template slot-scope="s">
                            <!-- 'sem_lancamento' NÃO vira presença: o rótulo é explícito. -->
                            <el-tag size="mini" :type="corPresenca(s.row.presenca)">
                                {{ rotuloPresenca(s.row.presenca) }}
                            </el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>

            <el-tab-pane label="Planejamento" name="planejamento">
                <div v-if="planejamentos.length === 0" class="pa-vazio">
                    Nenhum planejamento aprovado no período.
                </div>

                <div v-else>
                    <div v-for="(p, i) in planejamentos" :key="'p' + i" class="card-plan">
                        <div class="card-plan-topo">
                            <strong>{{ p.titulo || 'Planejamento' }}</strong>
                            <span class="pa-menor">{{ formatarData(p.data) }}</span>
                        </div>
                        <div v-if="p.componente" class="pa-menor">{{ p.componente }}</div>
                        <div v-if="p.competencia" class="linha-plan"><b>Competência:</b> {{ p.competencia }}</div>
                        <div v-if="p.habilidades" class="linha-plan"><b>Habilidades:</b> {{ p.habilidades }}</div>
                        <div v-if="p.conteudos" class="linha-plan"><b>Conteúdos:</b> {{ p.conteudos }}</div>
                        <div v-if="p.metodologia" class="linha-plan"><b>Metodologia:</b> {{ p.metodologia }}</div>
                    </div>
                </div>
            </el-tab-pane>

            <el-tab-pane label="Conteúdo ministrado" name="conteudos">
                <div v-if="conteudos.length === 0" class="pa-vazio">Nenhum conteúdo registrado no período.</div>

                <el-table v-else :data="conteudos" stripe size="mini" style="width:100%">
                    <el-table-column label="Data" width="100">
                        <template slot-scope="s">{{ formatarData(s.row.data) }}</template>
                    </el-table-column>
                    <el-table-column label="Componente" min-width="130">
                        <template slot-scope="s">{{ s.row.componente || '—' }}</template>
                    </el-table-column>
                    <el-table-column label="Conteúdo" min-width="220">
                        <template slot-scope="s">{{ s.row.conteudo || '—' }}</template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>

        </el-tabs>
    </div>
</template>

<script>
/**
 * BLOCO N — itens 7, 9 e 10.
 *
 * Consome `api/portal/aulas`, `/planejamentos` e `/conteudos`. O backend só devolve
 * planejamento APROVADO e nunca inclui observação do coordenador/diretor nem histórico de
 * aprovação — este componente não precisa (e não deve) filtrar nada disso por `v-if`.
 */
export default {
    name: 'PortalAulas',

    data () {
        const hoje = new Date()
        const primeiro = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
        const fmt = d => d.toISOString().substring(0, 10)

        return {
            loading: false, erro: null, aba: 'aulas',
            de: fmt(primeiro), ate: fmt(hoje),
            aulas: [], planejamentos: [], conteudos: []
        }
    },

    mounted () { this.carregar() },

    methods: {
        carregar () {
            this.loading = true
            this.erro = null

            const payload = { de: this.de, ate: this.ate }
            const cfg = this.$store.getters.getHeaderAuth
            const base = this.$store.state.config.baseUrlApi

            Promise.all([
                this.$axios.post(`${base}/api/portal/aulas`, payload, cfg),
                this.$axios.post(`${base}/api/portal/planejamentos`, payload, cfg),
                this.$axios.post(`${base}/api/portal/conteudos`, payload, cfg)
            ]).then(([a, p, c]) => {

                this.loading = false

                // Erro de qualquer um dos três é mostrado; nada é apresentado como sucesso.
                const erro = (a.data && a.data.erro) || (p.data && p.data.erro) || (c.data && c.data.erro)
                if (erro) { this.erro = erro; return }

                this.aulas = (a.data && a.data.aulas) || []
                this.planejamentos = (p.data && p.data.planejamentos) || []
                this.conteudos = (c.data && c.data.conteudos) || []

            }).catch(() => {
                this.loading = false
                this.erro = 'Não foi possível carregar as aulas do período.'
            })
        },

        formatarData (d) {
            if (!d) return '—'
            const p = String(d).substring(0, 10).split('-')
            return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : d
        },

        rotuloPresenca (v) {
            return {
                presente: 'Presente',
                falta: 'Falta',
                falta_justificada: 'Falta justificada',
                sem_lancamento: 'Sem lançamento'
            }[v] || '—'
        },

        corPresenca (v) {
            return { presente: 'success', falta: 'danger', falta_justificada: 'warning',
                     sem_lancamento: 'info' }[v] || 'info'
        }
    }
}
</script>

<style scoped>
.pa-loading { min-height: 300px; display: flex; justify-content: center; align-items: center; }
.pa-sub { color: #909399; }
.pa-menor { color: #909399; font-size: 12px; }
.pa-vazio { padding: 26px 12px; text-align: center; color: #909399; background: #fafafa; border-radius: 4px; }
.card-plan { border: 1px solid #ebeef5; border-radius: 4px; padding: 10px 12px; margin-bottom: 10px; }
.card-plan-topo { display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; }
.linha-plan { font-size: 13px; margin-top: 4px; word-break: break-word; }
.u-mt-5-mobile { margin-top: 0; }
@media (max-width: 640px) { .u-mt-5-mobile { margin-top: 6px; } }
</style>
